/* McQueens KR — shared theme JavaScript. No libraries, no build step.

   Sections that behave in a way nobody else does (the header, the story
   slider, the portfolio filter) keep their own <script>. This file holds
   what several pages share:

     1. helpers + money formatting
     2. cart: add to bag without leaving the page, live bag count
     3. favourites: the heart buttons, saved in the visitor's browser
     4. drawers: the slide-in enquiry / filter panels
     5. rails: horizontal product rows with arrows and a progress line
     6. product page: variant switching, gallery dots, recommendations
     7. header search suggestions
     8. small form conveniences (quantity steppers, auto-submit selects)

   window.MQ is set up in layout/theme.liquid with routes and translated
   strings, so nothing here hard-codes a URL or a sentence. */
(function () {
  'use strict';

  var MQ = window.MQ = window.MQ || {};
  var routes = MQ.routes || {};
  var t = MQ.strings || {};
  var docEl = document.documentElement;

  /* ── 1. helpers ───────────────────────────────────────────────────────── */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(type, sel, fn) {
    document.addEventListener(type, function (e) {
      var el = e.target && e.target.closest ? e.target.closest(sel) : null;
      if (el) fn(e, el);
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    url = String(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  MQ.$ = $; MQ.$$ = $$; MQ.esc = esc;

  // Shopify money format, e.g. "₩{{amount_no_decimals}}". Amounts arrive in
  // cents (the Ajax API) and zero is shown as "price on request".
  MQ.money = function (cents) {
    cents = typeof cents === 'string' ? Math.round(parseFloat(cents) * (cents.indexOf('.') > -1 ? 100 : 1)) : cents;
    if (!cents) return t.priceOnRequest || '';
    var fmt = MQ.moneyFormat || '{{amount_no_decimals}}';
    function group(n, dec, thousands, decimal) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 0, ',', '.');
      }
    });
  };

  // Wide letter-spacing suits English capitals but pulls Korean words
  // apart ("전 화 문 의"). Labels written in Hangul get normal spacing.
  var SPACED = '.mq-btn, .mq-link, .mq-eyebrow, .mq-pill, .mq-field__label, .mq-vp__label, ' +
    '.mq-drawer__title, .mq-footer__heading, .mq-card__eyebrow, .mq-tile__label, .mq-acc > summary, ' +
    '.mq-visit__fact dt, .mq-coll__tool, .mq-coll__count, .mq-post__date, .mq-art__meta, .mq-header__label, ' +
    '.mq-mega__navlink, .mq-mega__pill, .mq-mega__action, .mq-mega__card-label, .mq-mega__card-caption-main, ' +
    '.mq-story__overline, .mq-story__cta, .mq-phero__overline, .mq-phero__cta, .mq-rows__overline, ' +
    '.mq-rows__row-overline, .mq-rows__cta, .mq-enq__overline, .mq-enq__label, .mq-enq__submit, ' +
    '.mq-feat__eyebrow, .mq-ann__msg, .mq-footer__global, .mq-cart__remove, .mq-pred__label, .mq-pred__all, ' +
    '.mq-sr__cta-btn, .mq-sr__link';
  var HANGUL = /[\u3131-\u318E\uAC00-\uD7A3]/;
  MQ.markHangul = function (root) {
    $$(SPACED, root || document).forEach(function (el) {
      el.classList.toggle('mq-hangul', HANGUL.test(el.textContent));
    });
  };

  function lockScroll() { docEl.classList.add('mq-lock'); }
  function unlockScroll() {
    if (!$('.mq-drawer.is-open') && !$('[data-mq-header].mq-menu-open')) docEl.classList.remove('mq-lock');
  }

  /* ── 2. cart ──────────────────────────────────────────────────────────── */
  MQ.cart = {
    get: function () {
      return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },
    setCount: function (n) {
      $$('[data-mq-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
      $$('[data-mq-cart-item][data-hide-empty]').forEach(function (el) { el.hidden = n === 0; });
    }
  };

  var toast = $('[data-mq-toast]');
  var toastTimer = null;
  function showToast(item, error) {
    if (!toast) { if (!error) window.location.href = routes.cart; return; }
    toast.classList.toggle('is-error', !!error);
    var title = $('[data-mq-toast-title]', toast);
    if (title) title.textContent = error ? error : (t.added || '');
    if (item) {
      var img = $('[data-mq-toast-img]', toast);
      if (img) {
        img.hidden = !item.image;
        if (item.image) { img.src = sized(item.image, 200); img.alt = item.product_title || ''; }
      }
      var name = $('[data-mq-toast-name]', toast);
      if (name) name.textContent = item.product_title || '';
      var meta = $('[data-mq-toast-meta]', toast);
      if (meta) {
        var bits = [];
        if (item.variant_title && !/default/i.test(item.variant_title)) bits.push(item.variant_title);
        bits.push(MQ.money(item.final_line_price != null ? item.final_line_price : item.price));
        meta.textContent = bits.join(' · ');
      }
    }
    toast.classList.add('is-open');
    toast.setAttribute('aria-hidden', 'false');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, error ? 5000 : 7000);
  }
  function hideToast() {
    if (!toast) return;
    toast.classList.remove('is-open');
    toast.setAttribute('aria-hidden', 'true');
  }
  on('click', '[data-mq-toast-close]', hideToast);

  // Add to bag without a page load. If anything goes wrong the form simply
  // submits the old-fashioned way, so a customer can always buy.
  on('submit', 'form[data-mq-product-form]', function (e, form) {
    if (!window.fetch || !window.FormData) return;
    var btn = e.submitter || $('button[name="add"]', form);
    if (!btn || btn.name !== 'add' || btn.disabled) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    fetch(routes.cart_add + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        showToast(item);
        return MQ.cart.get().then(function (cart) { MQ.cart.setCount(cart.item_count); });
      })
      .catch(function (err) {
        showToast(null, (err && (err.description || err.message)) || t.cartError || 'Error');
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });

  /* ── 3. favourites ────────────────────────────────────────────────────── */
  // Saved per browser (localStorage), no account needed. Each entry keeps
  // just enough to draw a card: handle, title, url, image, price text.
  var FAV_KEY = 'mq:favorites:v1';
  MQ.favs = {
    list: function () {
      try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
    },
    save: function (list) {
      try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
      MQ.favs.sync();
      document.dispatchEvent(new CustomEvent('mq:favorites', { detail: list }));
    },
    toggle: function (data) {
      var list = MQ.favs.list();
      var i = -1;
      list.forEach(function (f, k) { if (f.h === data.h) i = k; });
      if (i > -1) list.splice(i, 1); else list.unshift(data);
      MQ.favs.save(list.slice(0, 60));
      return i === -1;
    },
    remove: function (handle) {
      MQ.favs.save(MQ.favs.list().filter(function (f) { return f.h !== handle; }));
    },
    sync: function () {
      var list = MQ.favs.list();
      var saved = {};
      list.forEach(function (f) { saved[f.h] = true; });
      $$('[data-mq-fav]').forEach(function (b) {
        var on = !!saved[b.getAttribute('data-mq-fav')];
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? (t.favRemove || '') : (t.favAdd || ''));
      });
      $$('[data-mq-fav-count]').forEach(function (c) {
        c.textContent = list.length;
        c.hidden = list.length === 0;
      });
    }
  };
  on('click', '[data-mq-fav]', function (e, b) {
    e.preventDefault();
    e.stopPropagation();
    var data;
    try { data = JSON.parse(b.getAttribute('data-mq-fav-data')); } catch (err) { data = null; }
    MQ.favs.toggle(data || { h: b.getAttribute('data-mq-fav') });
    b.classList.add('is-pop');
    setTimeout(function () { b.classList.remove('is-pop'); }, 280);
  });
  window.addEventListener('storage', function (e) { if (e.key === FAV_KEY) MQ.favs.sync(); });

  /* ── 4. drawers ───────────────────────────────────────────────────────── */
  var lastFocus = null;
  MQ.openDrawer = function (el) {
    if (!el || el.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lockScroll();
    setTimeout(function () {
      var f = $('[data-mq-autofocus]', el) || $('input:not([type="hidden"]), select, textarea, button', el);
      if (f) f.focus({ preventScroll: true });
    }, 120);
  };
  MQ.closeDrawer = function (el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    unlockScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  on('click', '[data-mq-open-drawer]', function (e, b) {
    var el = document.querySelector(b.getAttribute('data-mq-open-drawer'));
    if (!el) return;
    e.preventDefault();
    MQ.openDrawer(el);
  });
  on('click', '[data-mq-close-drawer]', function (e, b) { MQ.closeDrawer(b.closest('.mq-drawer')); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.mq-drawer.is-open').forEach(MQ.closeDrawer);
      hideToast();
    }
  });

  /* ── 5. rails ─────────────────────────────────────────────────────────── */
  if (window.customElements && !customElements.get('mq-rail')) {
    customElements.define('mq-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = $('.mq-rail__track', this);
        if (!this.track) return;
        this.thumb = $('.mq-rail__thumb', this);
        this.prev = $('[data-mq-rail-prev]', this);
        this.next = $('[data-mq-rail-next]', this);
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(this.update).observe(this.track);
        else window.addEventListener('resize', this.update);
        var self = this;
        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-mq-rail-prev]')) self.step(-1);
          else if (e.target.closest('[data-mq-rail-next]')) self.step(1);
        });
        this.update();
      }
      step(dir) {
        var track = this.track;
        var first = track.children[0];
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var w = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        var per = Math.max(1, Math.floor((track.clientWidth + gap) / w));
        track.scrollBy({ left: dir * w * per, behavior: 'smooth' });
      }
      update() {
        var track = this.track;
        var max = track.scrollWidth - track.clientWidth;
        var scrollable = max > 4;
        this.classList.toggle('is-scrollable', scrollable);
        if (!scrollable) return;
        var ratio = track.clientWidth / track.scrollWidth;
        var pos = Math.min(1, Math.max(0, track.scrollLeft / max));
        if (this.thumb) {
          this.thumb.style.width = (ratio * 100) + '%';
          this.thumb.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
        }
        if (this.prev) this.prev.disabled = track.scrollLeft < 4;
        if (this.next) this.next.disabled = track.scrollLeft > max - 4;
      }
    });
  }

  /* ── 6. product page ──────────────────────────────────────────────────── */
  MQ.product = {
    // Swap the price and the buy area for the chosen variant. The server
    // renders them (section rendering API), so labels such as "price on
    // request" or the reservation button stay in one place: the Liquid.
    update: function (section, variant) {
      var url = section.getAttribute('data-url');
      var sid = section.getAttribute('data-section-id');
      if (!variant) {
        $$('[data-mq-swap^="buy"] button[name="add"]', section).forEach(function (b) {
          b.disabled = true;
          b.textContent = t.unavailable || '';
        });
        return;
      }
      $$('input[name="id"]', section).forEach(function (i) { i.value = variant.id; });
      if (window.history && history.replaceState) history.replaceState(null, '', url + '?variant=' + variant.id);
      fetch(url + '?variant=' + variant.id + '&section_id=' + encodeURIComponent(sid))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          $$('[data-mq-swap]', section).forEach(function (el) {
            var fresh = doc.querySelector('[data-mq-swap="' + el.getAttribute('data-mq-swap') + '"]');
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
          MQ.favs.sync();
          MQ.markHangul(section);
          keepSiLabel();
        })
        .catch(function () { /* keep what is on screen */ });
      if (variant.featured_media) {
        var item = $('[data-media-id="' + variant.featured_media.id + '"]', section);
        if (item) MQ.product.showMedia(item);
      }
    },
    showMedia: function (item) {
      var track = item.parentElement;
      if (track && track.scrollWidth > track.clientWidth + 4) {
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }
  };

  on('change', '[data-mq-variant-picker] input, [data-mq-variant-picker] select', function (e, input) {
    var picker = input.closest('[data-mq-variant-picker]');
    var section = picker.closest('[data-mq-product]');
    var json = section ? $('[data-mq-variants]', section) : null;
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var chosen = $$('[data-mq-option]', picker).map(function (group) {
      var checked = $('input:checked', group);
      if (checked) return checked.value;
      var select = $('select', group);
      return select ? select.value : null;
    });
    $$('[data-mq-option]', picker).forEach(function (group, i) {
      var label = $('[data-mq-option-value]', group);
      if (label) label.textContent = chosen[i] || '';
    });
    var match = null;
    variants.forEach(function (v) {
      if (!match && v.options.every(function (o, i) { return o === chosen[i]; })) match = v;
    });
    MQ.product.update(section, match);
  });

  // Gallery dots on phones follow the swipe; tapping a dot jumps there.
  $$('[data-mq-gallery]').forEach(function (g) {
    var track = $('[data-mq-gallery-track]', g);
    var dots = $$('[data-mq-gallery-dot]', g);
    if (!track || !dots.length) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }, { passive: true });
    g.addEventListener('click', function (e) {
      var d = e.target.closest('[data-mq-gallery-dot]');
      if (d) track.scrollTo({ left: parseInt(d.getAttribute('data-mq-gallery-dot'), 10) * track.clientWidth, behavior: 'smooth' });
    });
  });

  // "You may also like": loads once the row is close to the screen.
  if (window.customElements && !customElements.get('mq-recs')) {
    customElements.define('mq-recs', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        if (!self.getAttribute('data-url') || self.dataset.loaded) return;
        var load = function () {
          self.dataset.loaded = '1';
          fetch(self.getAttribute('data-url'))
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('mq-recs');
              if (fresh && $('.mq-card', fresh)) {
                self.innerHTML = fresh.innerHTML;
                MQ.favs.sync();
              } else {
                var wrap = self.closest('.shopify-section');
                if (wrap) wrap.hidden = true;
              }
            })
            .catch(function () {});
        };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) { io.disconnect(); load(); }
          }, { rootMargin: '600px 0px' });
          io.observe(self);
        } else {
          load();
        }
      }
    });
  }

  /* ── 7. header search suggestions ─────────────────────────────────────── */
  // Shopify's predictive search API refuses Korean, so the suggestions are
  // the normal search results, drawn by sections/mq-predictive.liquid.
  (function () {
    var input = $('[data-mq-predictive-input]');
    var box = $('[data-mq-predictive]');
    if (!input || !box || !routes.search) return;
    var timer = null;
    var ctrl = null;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 250);
    });

    function run() {
      var q = input.value.trim();
      if (q.length < 1) { box.hidden = true; box.innerHTML = ''; return; }
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = routes.search + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&section_id=mq-predictive';
      box.setAttribute('aria-busy', 'true');
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-mq-pred-results]');
          box.innerHTML = res ? res.innerHTML : '';
          box.hidden = !res;
          box.removeAttribute('aria-busy');
          MQ.markHangul(box);
        })
        .catch(function () { box.removeAttribute('aria-busy'); });
    }
  })();

  /* ── 8. small form conveniences ───────────────────────────────────────── */
  // Quantity steppers: in the cart they submit straight away.
  on('click', '[data-mq-qty]', function (e, b) {
    var wrap = b.closest('.mq-qty');
    var input = wrap ? $('input', wrap) : null;
    if (!input) return;
    e.preventDefault();
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + (b.getAttribute('data-mq-qty') === 'plus' ? 1 : -1);
    input.value = Math.max(min, v);
    if (input.closest('[data-mq-cart-form]')) input.form.submit();
  });
  on('change', '[data-mq-cart-form] .mq-qty input', function (e, input) { input.form.submit(); });
  // Selects that apply themselves (collection sort order).
  on('change', '[data-mq-autosubmit]', function (e, el) { if (el.form) el.form.submit(); });

  /* ── Subscribe It keeps our label ──────────────────────────────────────── */
  // The reservation app replaces the button text with the caption set in the
  // app (Korean only). Put our translated label back whenever that happens.
  function keepSiLabel() {
    $$('#SI_trigger[data-mq-label]').forEach(function (btn) {
      if (btn.dataset.mqLabelWatch) return;
      btn.dataset.mqLabelWatch = '1';
      var want = btn.getAttribute('data-mq-label');
      var fix = function () { if (btn.textContent.trim() !== want) btn.textContent = want; };
      new MutationObserver(fix).observe(btn, { childList: true, characterData: true, subtree: true });
      fix();
    });
  }

  /* ── start ────────────────────────────────────────────────────────────── */
  MQ.favs.sync();
  MQ.markHangul();
  keepSiLabel();
  document.addEventListener('mq:favorites', function () { MQ.markHangul(); });
  // the theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', function (e) { MQ.markHangul(e.target); MQ.favs.sync(); });
  // A form inside a drawer that was just sent (or bounced with errors)
  // reopens its drawer so the visitor sees the result.
  $$('.mq-drawer[data-mq-autoopen]').forEach(MQ.openDrawer);
})();
